import { create } from "zustand";

type ThemesFilterState = {
  searchValue: string | null;
  statusFilter: string | null;
  ordering: string | null;
  setSearchValue: (searchValue: string | null) => void;
  setStatusFilter: (status: string | null) => void;
  setOrdering: (ordering: string | null) => void;
};

export const useThemesFilterStore = create<ThemesFilterState>((set) => ({
  searchValue: null,
  statusFilter: null,
  ordering: "-created_at",
  setSearchValue: (searchValue) => set({ searchValue }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setOrdering: (ordering) => set({ ordering }),
}));
